import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import template from '../../../constants/templates.constants';
import { TSitecoreContext } from '../../../types/types';
import {
  ContentHubSeriesListingFiltersFields,
  ContentHubSeriesListingFiltersProps,
  TLinesData,
  TLinesSeriesData,
  TSeriesData,
} from '../types/seriesListing.types';

export class SeriesListingModel {
  private readonly fields?: ContentHubSeriesListingFiltersFields;
  private readonly rendering?: ComponentRendering;
  private readonly context?: TSitecoreContext;

  constructor(props: ContentHubSeriesListingFiltersProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
    this.context = props?.sitecoreContext;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get lines(): TLinesData[] {
    return this.fields?.apiData?.lines?.items || [];
  }

  get linesSeries(): TLinesSeriesData[] {
    return this.fields?.apiData?.linesseries?.items || [];
  }
  
  get series(): TSeriesData[] {
    return this.fields?.apiData?.series?.items || [];
  }

  get currentLineTitle(): string {
    return this.fields?.apiData?.series?.parentTitle || '';
  }

  get isSuperSerie(): boolean {
    return this.context?.route?.templateId === template.productSuperseries;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
